import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { useResourceNotepadDataContextSafe } from '../../../../../resource-detail/components/context/resourceDataContext.js';
import { ColorLabel } from '../../components/ColorLabel.js';
import { ResourcePreviewTitle } from '../../components/Typography.js';
import { containerPreviewCompact } from '../cssPreviewContainer.js';
import { cssAspectRatio } from '../sharedCss.js';
import { getResourceNamePlaceholder } from '../../../../utils/getResourceTitle.js';
import EditorPreview from '../../../EditorPreview/EditorPreview.js';
import { cssVar } from '@fabric-app/ui/theme/variables';
import Divider from '@fabric-app/ui/components/Divider';
import { ResourceGridViewLoadingIndicator } from '../components/ResourceGridViewLoadingIndicator.js';

const ResourcePreviewNotepad = () => {
  const { resource } = useResourceNotepadDataContextSafe();
  return /* @__PURE__ */ jsxs(Wrapper, {
    "data-preview-content-wrapper": "notepad",
    children: [
      /* @__PURE__ */ jsx(ColorLabel, {
        absPosition: "inside-top-left"
      }),
      /* @__PURE__ */ jsx(ResourceGridViewLoadingIndicator, {
        resource
      }),
      /* @__PURE__ */ jsx(ResourcePreviewTitle, {
        children: resource.name || /* @__PURE__ */ jsx(TitlePlaceholder, {
          children: getResourceNamePlaceholder(resource)
        })
      }),
      /* @__PURE__ */ jsx(StyledDivider, {
        borderColor: "tertiary"
      }),
      resource.data.preview ? /* @__PURE__ */ jsx(StyledEditorPreview, {
        simplifyTables: false,
        withTruncator: true,
        data: resource.data.preview
      }, resource.id) : /* @__PURE__ */ jsx("div", {})
    ]
  });
};
const StyledDivider = styled(Divider).withConfig({
  displayName: "ResourcePreviewNotepad__StyledDivider",
  componentId: "sc-c1a9c52d-0"
})([
  ``,
  `{display:none;}`
], containerPreviewCompact);
const StyledEditorPreview = styled(EditorPreview).attrs({
  withTruncator: true
}).withConfig({
  displayName: "ResourcePreviewNotepad__StyledEditorPreview",
  componentId: "sc-c1a9c52d-1"
})([
  `flex-grow:1;flex-shrink:1;overflow:hidden;`,
  `{*{font-size:0.75rem !important;line-height:1rem !important;}}`
], containerPreviewCompact);
const TitlePlaceholder = styled.span.withConfig({
  displayName: "ResourcePreviewNotepad__TitlePlaceholder",
  componentId: "sc-c1a9c52d-2"
})([
  `opacity:0.5;`
]);
const Wrapper = styled.div.withConfig({
  displayName: "ResourcePreviewNotepad__Wrapper",
  componentId: "sc-c1a9c52d-3"
})([
  `width:100%;height:100%;display:flex;flex-direction:column;flex-grow:1;gap:0.75rem;overflow:hidden;padding:1rem;border-radius:var(--preview-content-border-radius,1.125rem);position:relative;border:var(--preview-border-width,2px) solid var(--preview-border-color,`,
  `);background:`,
  `;`,
  `;`,
  `{border:none;border-radius:0;padding:0.75rem;gap:0.625rem;}`
], cssVar["color-border-secondary"], cssVar["color-bg-note-primary"], cssAspectRatio, containerPreviewCompact);

export { ResourcePreviewNotepad, TitlePlaceholder };
//# sourceMappingURL=ResourcePreviewNotepad.js.map
